import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden" style={{ paddingTop: '108px' }}>

      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            "url('https://public.readdy.ai/ai/img_res/8abd8d4673b62706f22a89edc404d6b7.jpg')",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-r from-ecos-charcoal/98 via-ecos-charcoal/92 to-ecos-charcoal/70"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-ecos-charcoal/60 via-ecos-charcoal/30 to-ecos-charcoal/80"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 pt-10 pb-24">
        <div className="max-w-3xl">

          {/* Emergency badge */}
          <div className="inline-flex items-center gap-3 bg-ecos-green/20 border border-ecos-green/40 px-4 py-2 rounded-sm mb-10">
            <div className="w-1.5 h-1.5 bg-ecos-green rounded-full"></div>
            <span className="text-ecos-green text-xs font-semibold tracking-widest uppercase">24/7 Emergency Response Available</span>
          </div>

          <h1 className="font-serif text-white font-semibold leading-[1.02] mb-8" style={{ fontSize: 'clamp(2.8rem, 5.5vw, 5rem)' }}>
            Environmental Remediation &amp; Compliance Done Right —{' '}
            <em className="not-italic text-ecos-gold">The First Time.</em>
          </h1>

          <p className="text-white/65 text-lg lg:text-xl leading-relaxed mb-10 max-w-2xl">
            Certified environmental solutions for hazardous materials, site remediation, and disaster restoration across commercial, industrial, and government projects. EPA &amp; OSHA compliant — full documentation guaranteed.
          </p>

          <div className="flex flex-wrap gap-4 mb-14">
            <Link
              to="/#assessment"
              className="inline-flex items-center gap-2 bg-ecos-green hover:bg-ecos-green-light text-white font-semibold text-sm px-8 py-4 rounded-sm transition-all duration-200 cursor-pointer whitespace-nowrap hover:-translate-y-0.5"
            >
              Request Free Assessment
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line text-base"></i>
              </div>
            </Link>
            <a
              href="tel:+18888685420"
              className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/18 border border-white/25 hover:border-white/50 text-white font-medium text-sm px-8 py-4 rounded-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-fill text-base text-ecos-green"></i>
              </div>
              Call 888-868-5420
            </a>
          </div>

          {/* Trust micro-badges */}
          <div className="flex flex-wrap items-center gap-8 pt-8 border-t border-white/12">
            {[
              { icon: 'ri-shield-check-line', text: 'Licensed & Insured' },
              { icon: 'ri-government-line', text: 'Gov. Approved' },
              { icon: 'ri-medal-line', text: '25+ Years Experience' },
              { icon: 'ri-star-fill', text: '4.9★ Rating' },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${item.icon} text-ecos-green text-sm`}></i>
                </div>
                <span className="text-white/55 text-sm font-medium">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
        <span className="text-white/30 text-xs uppercase tracking-widest">Scroll</span>
        <div className="w-px h-10 bg-gradient-to-b from-white/30 to-transparent"></div>
      </div>

    </section>
  );
}
